import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { userSlice } from "./slices/user";
import { addNewSlice } from "./slices/addNew";
import { loadingCellsSlice } from "./slices/loadingCells";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../api";
import { createLogger } from "redux-logger";
import { rtkQueryErrorWatcher } from "../api/middleware.ts";
import { createFormSlice } from "./slices/createForm.ts";

// Create logger middleware
const loggerMiddleware = createLogger({
  collapsed: true,
});

// Determine if we're in production mode
const isProduction = process.env.NODE_ENV === "production";

export const store = configureStore({
  reducer: {
    [userSlice.name]: userSlice.reducer,
    [addNewSlice.name]: addNewSlice.reducer,
    [createFormSlice.name]: createFormSlice.reducer,
    [loadingCellsSlice.name]: loadingCellsSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    // Add logger middleware only in non-production environments
    return isProduction
      ? getDefaultMiddleware().concat(api.middleware, rtkQueryErrorWatcher)
      : getDefaultMiddleware().concat(
          api.middleware,
          rtkQueryErrorWatcher,
          loggerMiddleware,
        );
  },
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
